module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/arrow-down-circle-51ec259a02d4954cf062c3b823acd050.png";